const zh = {
  menu1: "首页",
  menu2: "预售",
  menu3: "链游生态",
  menu4: "Xsparkpool 糖浆池",
  menu5: "机枪池",
  notAnZ: "登录钱包",
  logout: "退出登录",
  logTip:'请先登录钱包',
  buyBtn: "买入Sparky",
  panel1:'欧意技术团队',
  panel2:'公平公正的DAO',
  panel3:'高额权益分红',
  Equity:'权益数据面板',
  Profits:'黑洞收益',
  Principal:'本金',
  Received:'获得',
  returns:'LP收益',
  total:"全网累计打入黑洞的XSpark ",
  Benefits:'什么是XSPARK/ x链火花？',
  BenefitsInfo1:'由参与者CTODAO治理构建了安全公平透明的数字平台，服务于全球众多国家和地区用户',
  BenefitsInfo2:'多原生态激发无限可能',
  BenefitsInfo3:'DEFI生态融合糖浆池',
  BenefitsInfo4:'＋机枪池',
  BenefitsInfo5:'＋链游',
  BenefitsInfo6:'＋swap手续费分配',
  BenefitsInfo7:'＋BTC矿场等',
  BenefitsInfo8:'技术创新引领',
  BenefitsInfo9:'前沿区块链技术引领数字经济新时代',
  profile1:'XSPARK代币及生态均由欧意技术团队开发，底池部署在XLAYERSWAP并由其协助审计  。  由散户联合组建的Spark Grant 火花基金会  ，以CTODAO治理的运转方式开启散户联合做庄，为X链上优质的生态开发者提供 《创新的花火》。',
  profile2:'创新的技术开发，公平公正透明的社区治理代币分配经济学，势必将打造成Xlayer 第一龙头社区。',
  tixiTitle:'通过以下创新打造多元化金融体系',
  tixiSubtitle1:'通缩稀缺',
  tixiDes1:'黑洞销毁1.5倍金本位OKB收益',
  tixiDes2:'回购销毁推动长期价值增长，强化代币的稀缺属性',
  tixiDes3:'生态使用消耗＋销毁',
  tixiSubtitle2:'收益多元',
  tixiDes4:'做市、共建、分红等多重回报，满足不同需求',
  tixiDes5:'底池激励智能策略推动LP底池不断增长，提升生态资金韧性',
  tixiDes6:'链上数据读取无需质押LP自动进入糖浆池获取一些列分红＋治理权益',
  tixiSubtitle3:'DAO自治社区共建共享',
  tixiDes7:'实现高度共识，增强社区凝聚力',
  youshiTitle:'XSPARK的核心优势',
  youshiDes1:'市场资金扶持火花基金会专项投入 500 万美金，支持xsparkDAO治理协议发展全球各地市场俱乐部与社区工作室',
  youshiDes2:'多重福利机遇丰富福利政策已就位，诚邀参与共享发展红利',
  youshiDes3:'全球市场流量桥梁连接全球数万用户与全球开发者，海量曝光度，加速技术与生态互通',
  youshiDes4:'各大交易所鼎力相助共建共识x链第一DAO治理龙一社区成长历程',
  nodePresale:'XSpark节点预售',
  Whitelist:'白名单',
  yes:'是',
  no:'否',
  isWhite:'您不是白名单用户',
  Price:'价格',
  TotalQuantity:'总量',
  Sold:'已售',
  buyBtn1: "购买",
  parentAddress:'上级地址',
  General:'XSpark普通预售',
  purchased:'我购买的',
  node:'节点',
  presale:'预售',
  Recommendation:'我的推荐',
  recNum:'推荐人数',
  Referral:'推荐奖励',


  copy: "复制推荐链接",
  success: "成功",
  failed: "失败",
  quxiao: "取消",
  shouquan: "授权",
};
export default zh;
